export const environment = {
  production: false,
  apiUrl: '/api',
  householdApiUrl: '/household-service/api',
  culinaryApiUrl: '/culinary-service/api',
};
